import { Button, Result } from "antd-v5";
import React, { useCallback } from "react";

interface Page500Props {
  onRedirect?: () => void;
}

const Page500: React.FC<Page500Props> = ({ onRedirect }) => {
  const onClick = useCallback(() => {
    window.location.href = window.location.origin;
  }, []);
  return (
    <Result
      subTitle="Sorry, something went wrong. We are looking into this issue."
      extra={
        <Button onClick={onClick} type="primary">
          Back Home
        </Button>
      }
    />
  );
};

export default Page500;
